import React from 'react';
import { X, Calendar, MapPin, Users, Clock, Star, Tag, Building } from 'lucide-react';

const EventDetails = ({ event, onClose, onRegister }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long',
      year: 'numeric',
      month: 'long', 
      day: 'numeric' 
    });
  };

  const availableSpots = event.capacity - event.registered;
  const fillPercentage = (event.registered / event.capacity) * 100;

  return React.createElement('div', { 
    className: 'modal-overlay', 
    onClick: onClose 
  },
    React.createElement('div', { 
      className: 'event-details-modal', 
      onClick: (e) => e.stopPropagation() 
    },
      React.createElement('button', { 
        onClick: onClose, 
        className: 'modal-close' 
      },
        React.createElement(X, { size: 24 })
      ),
      
      React.createElement('div', { className: 'event-details-header' },
        React.createElement('img', { 
          src: event.image, 
          alt: event.title, 
          className: 'event-details-image' 
        }),
        React.createElement('div', { className: 'event-details-overlay' },
          React.createElement('div', { className: 'event-details-badges' },
            React.createElement('span', { className: 'category-badge' }, event.category),
            event.featured &&
              React.createElement('span', { className: 'featured-badge' },
                React.createElement(Star, { size: 16 }),
                'Featured'
              )
          ),
          React.createElement('h1', { className: 'event-details-title' }, event.title),
          React.createElement('p', { className: 'event-details-organizer' },
            React.createElement(Building, { size: 16 }),
            `Organized by ${event.organizer}`
          )
        )
      ),
      
      React.createElement('div', { className: 'event-details-content' },
        React.createElement('div', { className: 'event-details-main' },
          React.createElement('div', { className: 'event-description' },
            React.createElement('h3', null, 'About This Event'),
            React.createElement('p', null, event.description)
          ),
          
          React.createElement('div', { className: 'event-tags-section' },
            React.createElement('h4', null, 'Topics Covered'),
            React.createElement('div', { className: 'event-tags-grid' },
              event.tags.map((tag, index) =>
                React.createElement('span', { 
                  key: index, 
                  className: 'event-tag-detailed' 
                },
                  React.createElement(Tag, { size: 14 }),
                  tag
                )
              )
            )
          )
        ),
        
        React.createElement('div', { className: 'event-details-sidebar' },
          React.createElement('div', { className: 'event-info-card' },
            React.createElement('div', { className: 'event-price-section' },
              React.createElement('span', { className: 'price-label' }, 'Price'),
              React.createElement('span', { className: 'price-value' }, `$${event.price}`)
            ),
            
            React.createElement('div', { className: 'event-details-info' },
              React.createElement('div', { className: 'info-item' },
                React.createElement(Calendar, { size: 20 }),
                React.createElement('div', null,
                  React.createElement('strong', null, formatDate(event.date)),
                  React.createElement('span', null, 'Date')
                )
              ),
              
              React.createElement('div', { className: 'info-item' },
                React.createElement(Clock, { size: 20 }),
                React.createElement('div', null,
                  React.createElement('strong', null, event.time),
                  React.createElement('span', null, 'Start Time')
                )
              ),
              
              React.createElement('div', { className: 'info-item' },
                React.createElement(MapPin, { size: 20 }),
                React.createElement('div', null,
                  React.createElement('strong', null, event.location),
                  React.createElement('span', null, 'Venue')
                )
              ),
              
              React.createElement('div', { className: 'info-item' },
                React.createElement(Users, { size: 20 }),
                React.createElement('div', null,
                  React.createElement('strong', null, `${event.registered} / ${event.capacity}`),
                  React.createElement('span', null, 'Attendees')
                )
              )
            ),
            
            React.createElement('div', { className: 'capacity-section' },
              React.createElement('div', { className: 'capacity-header' },
                React.createElement('span', null, 'Registration Status'),
                React.createElement('span', null, `${availableSpots} spots left`)
              ),
              React.createElement('div', { className: 'capacity-bar' },
                React.createElement('div', { 
                  className: 'capacity-fill', 
                  style: { width: `${fillPercentage}%` } 
                })
              )
            ),
            
            React.createElement('button', {
              onClick: () => onRegister(event),
              className: 'btn-primary full-width',
              disabled: availableSpots === 0
            }, availableSpots === 0 ? 'Event Full' : 'Register Now')
          )
        )
      )
    )
  );
};

export default EventDetails;